import { sfaConfigurationValuesTypes } from "../../types";
export const initialSfaValues: sfaConfigurationValuesTypes = {
    storeInRange: {
        "name": "storeInRange",
        "type": "number",
        "value": 0,
        "docUrl": "",
        "description": " Outlet Range",
        "possibleVals": [] 
    },
    loaderFailedText: {
        "name": "loaderFailedText",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "load failure text",
        "possibleVals": [
            "string"
        ]
    },
    pjpLabel:{
        "name": "pjpLabel",
        "type": "string",
        "value": "PJP",
        "docUrl": "",
        "description": "PJP label in outlet screen",
        "possibleVals": [
          "PJP",
          "CPG"
        ]
      },


      additionalMessage: {
        "name": "additionalMessage",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "additionalMessage",
        "possibleVals": [
            "string"
        ]
    },
    forceUpdateConfig: {
        "name": "forceUpdateConfig",
        "type":"list",
        "value": [
          {
            "showForceUpdate": false,
            "latestIosVersion": "1.0.0",
            "latestAndroidVersion": "1.0.0"
          }
        ],
        "docUrl": "",
        "description": "Configuration to show force update screen as soon as the user opens the app.",
        "possibleVals": []
    }
}

